var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"page-title",class:{sub: _vm.sub}},[_c('div',{staticClass:"float-left"},[_c('div',{staticClass:"title"},[_vm._t("default")],2)]),_vm._v(" "),_c('div',{staticClass:"float-right"},[_vm._t("right")],2),_vm._v(" "),_vm._t("append")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }